import styled from 'styled-components';

import { Logo as LogoElement } from '~/elements/Logo';

export const Logo = styled(LogoElement)`
  margin: auto;
`;

export const animateLogo = (
  logo: SVGElement,
  logoWrapper: HTMLDivElement,
  panel: HTMLDivElement,
  gs: any,
  pathPlugin: any,
  callback: () => void
) => {
  gs.registerPlugin(pathPlugin);

  const element = logo.getBoundingClientRect();
  const letters = logo.querySelectorAll(':scope > path');
  const shape = logo.querySelector('g path');

  const sidebarPlaceholders = document.getElementsByClassName('sidebar-placeholder');
  const sidebarPlaceholder = sidebarPlaceholders.length > 0 ? sidebarPlaceholders[0] : null;

  // Try to find the actual sidebar logo to get accurate target coordinates
  const sidebarLogo = document.querySelector('[data-logo-target]') as SVGElement;
  let targetX = 3;
  let targetY = 14;

  if (sidebarLogo) {
    const targetRect = sidebarLogo.getBoundingClientRect();
    targetX = targetRect.left;
    targetY = targetRect.top;
  }

  if (element && letters) {
    gs.to(logoWrapper, {
      x: '0px',
      duration: 1.2,
    });
    gs.to(shape, {
      opacity: 0,
      duration: 0.6,
    });
    gs.to(logo, {
      motionPath: {
        path: [
          { x: -(element.left - targetX) / 1.9, y: -(element.top - targetY) / 1.4 },
          { x: -(element.left - targetX), y: -(element.top - targetY) },
        ],
        alignOrigin: [0.5, 0.5],
        curviness: 0.75,
      },
      duration: 1,
    });
    gs.to(logo, {
      rotate: '5deg',
      repeat: 1,
      yoyo: true,
      duration: 0.5,
    });
    gs.to(logo, {
      scale: 0.6666,
      duration: 0.9,
    });
    gs.to(letters, {
      stagger: -0.08,
      '--logo-path-opacity': 1,
      '--logo-path-x': '-1px',
      '--logo-path-y': '7px',
      duration: 1,
      onComplete: callback,
    });
    gs.to(panel, {
      '--panel-o': 0,
      '--panel-y': '0px',
      '--panel-s': 0.9,
      duration: 0.35,
    });
    gs.to(sidebarPlaceholder, {
      x: '100%',
      opacity: 1,
      duration: 0.8,
      delay: 0.2,
    });
  }
};
